import React from "react";

interface Props {
  imgSrc: string;
  deviceType: "ios" | "android" | "frame";
}

const Phone = ({ imgSrc, deviceType }: Props) => {
  return (
    <div>
      {deviceType === "ios" && (
        <div className="device device-iphone-x m-auto" style={{ zoom: 0.75 }}>
          <a
            href="https://www.puls4.com/2-minuten-2-millionen/staffel-7/videos/Beitraege/Getsby-im-Pitch-805619"
            className="absolute z-10"
            style={{ right: "-25px", top: "-25px" }}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={require("./../images/2min2mio_badge.png")}
              width="200px"
              height="200px"
              alt="Bekannt aus 2 Minuten 2 Millionen"
            />
          </a>
          <div className="device-frame">
            <img className="device-content" src={imgSrc} alt="" />
          </div>
          <div className="device-stripe" />
          <div className="device-header" />
          <div className="device-sensors" />
          <div className="device-btns" />
          <div className="device-power" />
          <div className="device-home" />
        </div>
      )}
      {deviceType === "android" && (
        <div
          className="device device-google-pixel device-black m-auto"
          style={{ zoom: 0.75 }}
        >
          <a
            href="https://www.puls4.com/2-minuten-2-millionen/staffel-7/videos/Beitraege/Getsby-im-Pitch-805619"
            className="absolute z-10"
            style={{ right: "-25px", top: "-25px" }}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={require("./../images/2min2mio_badge.png")}
              width="200px"
              height="200px"
              alt="Bekannt aus 2 Minuten 2 Millionen"
            />
          </a>
          <div className="device-frame">
            <img className="device-content" src={imgSrc} alt="" />
          </div>
          <div className="device-stripe" />
          <div className="device-header" />
          <div className="device-sensors" />
          <div className="device-btns" />
          <div className="device-power" />
        </div>
      )}
      {deviceType === "frame" && (
        <div className="relative w-full p-8">
          <a
            href="https://www.puls4.com/2-minuten-2-millionen/staffel-7/videos/Beitraege/Getsby-im-Pitch-805619"
            className="absolute z-1"
            style={{ right: "-25px", top: "-25px" }}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={require("./../images/2min2mio_badge.png")}
              width="150px"
              height="150px"
              alt="Bekannt aus 2 Minuten 2 Millionen"
            />
          </a>
          <img
            src={imgSrc}
            style={{
              border: "15px solid #222",
              borderRadius: "5px",
              borderBottomWidth: "30px",
              borderTopWidth: "30px"
            }}
            alt=""
          />
        </div>
      )}
    </div>
  );
};

export default Phone;
